// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".js?" + {"0":"99d4c617f27045fe4b64","3":"f74304b9de8489f0cbf5","4":"f64f1f853252e5687a56","5":"9837c03bfc15955f3b3c"}[chunkId] + "";
};